import React from 'react';

import UserFilter from 'components/Filters/UserFilter';

import { Filter } from '@gogame/filters';

import {
  FILTER_FILTERSTATUSES,
  FILTER_AUDIENCES,
  FILTER_PARTNERS,
  FILTER_DATA_TYPES,
  FILTER_ACCOUNTS,
  FILTER_CREATED_BY,
  FILTER_APPLICATIONS,
  FILTERS_DEPENDENCIES as DEPENDENCIES,
  FILTER_OWNERS,
} from 'scenes/CustomAudiences/PartnerAudiences/constants';
import * as filtersSource from 'scenes/CustomAudiences/PartnerAudiences/sources/filters';

export const Statuses = (props) => {
  return (
    <Filter.MultiSelect
      title={'Statuses'}
      name={FILTER_FILTERSTATUSES}
      source={filtersSource.loadFilterStatuses}
      depends={DEPENDENCIES[FILTER_FILTERSTATUSES]}
      placeholder={'All'}
      {...props}
    />
  );
};

export const Audiences = (props) => {
  return (
    <Filter.MultiSelect
      title={'Audiences'}
      name={FILTER_AUDIENCES}
      source={filtersSource.loadAudiences}
      depends={DEPENDENCIES[FILTER_AUDIENCES]}
      placeholder={'All'}
      {...props}
    />
  );
};

export const Partners = (props) => {
  return (
    <Filter.MultiSelect
      title={'Partners'}
      name={FILTER_PARTNERS}
      source={filtersSource.loadPartners}
      depends={DEPENDENCIES[FILTER_PARTNERS]}
      placeholder={'All'}
      {...props}
    />
  );
};

export const DataTypes = (props) => {
  return (
    <Filter.MultiSelect
      title={'Data types'}
      name={FILTER_DATA_TYPES}
      source={filtersSource.loadDataTypes}
      depends={DEPENDENCIES[FILTER_DATA_TYPES]}
      placeholder={'All'}
      {...props}
    />
  );
};

export const Accounts = (props) => {
  return (
    <Filter.MultiSelect
      title={'Accounts'}
      name={FILTER_ACCOUNTS}
      source={filtersSource.loadAccounts}
      depends={DEPENDENCIES[FILTER_ACCOUNTS]}
      placeholder={'All'}
      {...props}
    />
  );
};

export const CreatedBy = (props) => {
  return (
    <UserFilter
      title={'Created By'}
      name={FILTER_CREATED_BY}
      source={filtersSource.loadCreatedBy}
      depends={DEPENDENCIES[FILTER_CREATED_BY]}
      placeholder={'All'}
      {...props}
    />
  );
};

export const Applications = (props) => {
  return (
    <Filter.MultiSelect
      title={'Applications'}
      name={FILTER_APPLICATIONS}
      source={filtersSource.loadApplications}
      placeholder={'All'}
      {...props}
    />
  );
};

export const Owners = (props) => {
  return (
    <UserFilter
      title={'Owners'}
      name={FILTER_OWNERS}
      source={filtersSource.loadOwners}
      depends={DEPENDENCIES[FILTER_OWNERS]}
      placeholder={'All'}
      {...props}
    />
  );
};
